// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.region-manager-content {
  --overflow: hidden;
  --padding-top: 0;
  --padding-bottom: 0;
  --padding-start: 0;
  --padding-end: 0;
}

.body-layout {
  display: flex;
  height: 100%;
  overflow: hidden;
}

.left-panel {
  width: 48%;
  min-width: 280px;
  max-width: 480px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  padding: 12px 12px 10px;
  border-right: 1px solid rgba(0, 0, 0, 0.08);
  background: var(--ion-background-color, #fff);
}

.tab-bar {
  display: flex;
  flex-shrink: 0;
  border-bottom: 2px solid rgba(var(--ion-color-primary-rgb), 0.14);
  margin-bottom: 10px;
}

.tab-btn {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  padding: 9px 10px;
  background: transparent;
  border: 0;
  border-bottom: 2px solid transparent;
  margin-bottom: -2px;
  font-size: var(--font-size-small);
  font-weight: 500;
  color: var(--ion-color-medium);
  cursor: pointer;
  transition: color 0.18s ease, border-color 0.18s ease;
}
.tab-btn ion-icon {
  font-size: 15px;
}
.tab-btn.active {
  color: var(--ion-color-primary);
  font-weight: 700;
  border-bottom-color: var(--ion-color-primary);
}
.tab-btn:hover:not(.active) {
  color: var(--ion-color-dark);
  background: rgba(var(--ion-color-primary-rgb), 0.04);
}

.tab-content {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
  overflow-y: auto;
  padding-right: 2px;
}
.tab-content::-webkit-scrollbar {
  width: 5px;
}
.tab-content::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.18);
  border-radius: 4px;
}

.group-section {
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 12px;
  overflow: hidden;
  background: var(--ion-background-color, #fff);
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
  flex-shrink: 0;
}

.group-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 9px 13px;
  background: rgba(var(--ion-color-light-rgb), 0.75);
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}

.group-header-left {
  display: flex;
  align-items: center;
  gap: 7px;
  font-weight: 600;
  font-size: 12px;
  color: var(--ion-color-dark);
}
.group-header-left ion-icon {
  font-size: 16px;
  color: var(--ion-color-primary);
}

.group-header-right {
  display: flex;
  align-items: center;
}
.group-header-right ion-button {
  --padding-start: 4px;
  --padding-end: 4px;
  height: 28px;
}

.group-body {
  padding: 6px 10px 8px;
  display: flex;
  flex-direction: column;
  min-height: 80px;
  max-height: 260px;
  overflow-y: auto;
}
.group-body::-webkit-scrollbar {
  width: 4px;
}
.group-body::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.15);
  border-radius: 4px;
}
.group-body.group-body--form {
  min-height: unset;
  max-height: unset;
  overflow-y: visible;
  padding: 0;
}

.group-section.tree-section {
  flex: 1;
  min-height: 0;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
.group-section.tree-section .group-body {
  flex: 1;
  min-height: 0;
  max-height: unset;
}

.selected-region-feedback {
  display: flex;
  align-items: center;
  gap: 7px;
  padding: 7px 12px;
  border-radius: 8px;
  background: rgba(var(--ion-color-medium-rgb), 0.08);
  border: 1px solid rgba(var(--ion-color-medium-rgb), 0.15);
  font-size: var(--font-size-small);
  color: var(--ion-color-medium);
  flex-shrink: 0;
}
.selected-region-feedback ion-icon {
  font-size: 17px;
  flex-shrink: 0;
}
.selected-region-feedback span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.selected-region-feedback.has-selection {
  background: rgba(var(--ion-color-success-rgb), 0.09);
  border-color: rgba(var(--ion-color-success-rgb), 0.3);
  color: var(--ion-color-success-shade);
}
.selected-region-feedback.has-selection ion-icon {
  color: var(--ion-color-success);
}

.panel-footer {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 6px;
  padding-top: 10px;
  border-top: 1px solid rgba(0, 0, 0, 0.06);
  margin-top: 8px;
}

.map-panel {
  flex: 1;
  min-width: 0;
  position: relative;
  display: flex;
  flex-direction: column;
}
.map-panel app-leaflet-map {
  flex: 1;
  min-height: 0;
  display: block;
  height: 100%;
}

.map-mode-badge {
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 1000;
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 5px 11px;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 700;
  background: rgba(var(--ion-color-light-rgb), 0.9);
  color: var(--ion-color-medium);
  border: 1px solid rgba(var(--ion-color-medium-rgb), 0.22);
  backdrop-filter: blur(4px);
  pointer-events: none;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.12);
}
.map-mode-badge ion-icon {
  font-size: 13px;
}
.map-mode-badge.draw-mode {
  background: rgba(var(--ion-color-primary-rgb), 0.14);
  color: var(--ion-color-primary);
  border-color: rgba(var(--ion-color-primary-rgb), 0.38);
}`, "",{"version":3,"sources":["webpack://./src/app/components/trajectory-creation/select-region-area/select-region-area.component.scss"],"names":[],"mappings":"AAMA;EACE,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;AALF;;AASA;EACE,aAAA;EACA,YAAA;EACA,gBAAA;AANF;;AAUA;EACE,UAAA;EACA,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,uBAAA;EACA,2CAAA;EACA,6CAAA;AAPF;;AAWA;EACE,aAAA;EACA,cAAA;EACA,iEAAA;EACA,mBAAA;AARF;;AAWA;EACE,OAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,iBAAA;EACA,uBAAA;EACA,SAAA;EACA,oCAAA;EACA,mBAAA;EACA,iCAAA;EACA,gBAAA;EACA,8BAAA;EACA,eAAA;EACA,qDAAA;AARF;AAUE;EACE,eAAA;AARJ;AAWE;EACE,+BAAA;EACA,gBAAA;EACA,6CAAA;AATJ;AAYE;EACE,4BAAA;EACA,oDAAA;AAVJ;;AAeA;EACE,OAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;EACA,gBAAA;EACA,kBAAA;AAZF;AAcE;EAAuB,UAAA;AAXzB;AAYE;EACE,+BAAA;EACA,kBAAA;AAVJ;;AAeA;EACE,qCAAA;EACA,mBAAA;EACA,gBAAA;EACA,6CAAA;EACA,yCAAA;EACA,cAAA;AAZF;;AAeA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,iBAAA;EACA,kDAAA;EACA,4CAAA;AAZF;;AAeA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,eAAA;EACA,4BAAA;AAZF;AAcE;EACE,eAAA;EACA,+BAAA;AAZJ;;AAgBA;EACE,aAAA;EACA,mBAAA;AAbF;AAeE;EACE,oBAAA;EACA,kBAAA;EACA,YAAA;AAbJ;;AAiBA;EACE,qBAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;AAdF;AAgBE;EAAuB,UAAA;AAbzB;AAcE;EACE,+BAAA;EACA,kBAAA;AAZJ;AAgBE;EACE,iBAAA;EACA,iBAAA;EACA,mBAAA;EACA,UAAA;AAdJ;;AAmBA;EACE,OAAA;EACA,aAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;AAhBF;AAkBE;EACE,OAAA;EACA,aAAA;EACA,iBAAA;AAhBJ;;AAqBA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,kBAAA;EACA,mDAAA;EACA,yDAAA;EACA,iCAAA;EACA,8BAAA;EACA,cAAA;AAlBF;AAoBE;EACE,eAAA;EACA,cAAA;AAlBJ;AAqBE;EACE,gBAAA;EACA,uBAAA;EACA,mBAAA;AAnBJ;AAsBE;EACE,oDAAA;EACA,qDAAA;EACA,qCAAA;AApBJ;AAsBI;EAAW,+BAAA;AAnBf;;AAwBA;EACE,cAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,QAAA;EACA,iBAAA;EACA,yCAAA;EACA,eAAA;AArBF;;AAyBA;EACE,OAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;AAtBF;AAwBE;EACE,OAAA;EACA,aAAA;EACA,cAAA;EACA,YAAA;AAtBJ;;AA2BA;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,iDAAA;EACA,8BAAA;EACA,yDAAA;EACA,0BAAA;EACA,oBAAA;EACA,yCAAA;AAxBF;AA0BE;EAAW,eAAA;AAvBb;AAyBE;EACE,oDAAA;EACA,+BAAA;EACA,sDAAA;AAvBJ","sourcesContent":["// ============================================================\r\n//  region-manager  — unified select + create panel\r\n//  Design language: oprequest-summary (group-sections, shadows)\r\n// ============================================================\r\n\r\n// ── Ion-content shell ────────────────────────────────────────\r\n.region-manager-content {\r\n  --overflow: hidden;\r\n  --padding-top: 0;\r\n  --padding-bottom: 0;\r\n  --padding-start: 0;\r\n  --padding-end: 0;\r\n}\r\n\r\n// ── Root layout ──────────────────────────────────────────────\r\n.body-layout {\r\n  display: flex;\r\n  height: 100%;\r\n  overflow: hidden;\r\n}\r\n\r\n// ── Left panel ───────────────────────────────────────────────\r\n.left-panel {\r\n  width: 48%;\r\n  min-width: 280px;\r\n  max-width: 480px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  overflow: hidden;\r\n  padding: 12px 12px 10px;\r\n  border-right: 1px solid rgba(0, 0, 0, 0.08);\r\n  background: var(--ion-background-color, #fff);\r\n}\r\n\r\n// ── Tab bar ──────────────────────────────────────────────────\r\n.tab-bar {\r\n  display: flex;\r\n  flex-shrink: 0;\r\n  border-bottom: 2px solid rgba(var(--ion-color-primary-rgb), 0.14);\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.tab-btn {\r\n  flex: 1;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 5px;\r\n  padding: 9px 10px;\r\n  background: transparent;\r\n  border: 0;\r\n  border-bottom: 2px solid transparent;\r\n  margin-bottom: -2px;\r\n  font-size: var(--font-size-small);\r\n  font-weight: 500;\r\n  color: var(--ion-color-medium);\r\n  cursor: pointer;\r\n  transition: color 0.18s ease, border-color 0.18s ease;\r\n\r\n  ion-icon {\r\n    font-size: 15px;\r\n  }\r\n\r\n  &.active {\r\n    color: var(--ion-color-primary);\r\n    font-weight: 700;\r\n    border-bottom-color: var(--ion-color-primary);\r\n  }\r\n\r\n  &:hover:not(.active) {\r\n    color: var(--ion-color-dark);\r\n    background: rgba(var(--ion-color-primary-rgb), 0.04);\r\n  }\r\n}\r\n\r\n// ── Tab content ──────────────────────────────────────────────\r\n.tab-content {\r\n  flex: 1;\r\n  min-height: 0;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 8px;\r\n  overflow-y: auto;\r\n  padding-right: 2px; // room for scrollbar\r\n\r\n  &::-webkit-scrollbar { width: 5px; }\r\n  &::-webkit-scrollbar-thumb {\r\n    background: rgba(0, 0, 0, 0.18);\r\n    border-radius: 4px;\r\n  }\r\n}\r\n\r\n// ── Group sections (oprequest-summary style) ─────────────────\r\n.group-section {\r\n  border: 1px solid rgba(0, 0, 0, 0.08);\r\n  border-radius: 12px;\r\n  overflow: hidden;\r\n  background: var(--ion-background-color, #fff);\r\n  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);\r\n  flex-shrink: 0;\r\n}\r\n\r\n.group-header {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  padding: 9px 13px;\r\n  background: rgba(var(--ion-color-light-rgb), 0.75);\r\n  border-bottom: 1px solid rgba(0, 0, 0, 0.06);\r\n}\r\n\r\n.group-header-left {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 7px;\r\n  font-weight: 600;\r\n  font-size: 12px;\r\n  color: var(--ion-color-dark);\r\n\r\n  ion-icon {\r\n    font-size: 16px;\r\n    color: var(--ion-color-primary);\r\n  }\r\n}\r\n\r\n.group-header-right {\r\n  display: flex;\r\n  align-items: center;\r\n\r\n  ion-button {\r\n    --padding-start: 4px;\r\n    --padding-end: 4px;\r\n    height: 28px;\r\n  }\r\n}\r\n\r\n.group-body {\r\n  padding: 6px 10px 8px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  min-height: 80px;\r\n  max-height: 260px;\r\n  overflow-y: auto;\r\n\r\n  &::-webkit-scrollbar { width: 4px; }\r\n  &::-webkit-scrollbar-thumb {\r\n    background: rgba(0, 0, 0, 0.15);\r\n    border-radius: 4px;\r\n  }\r\n\r\n  // NewRegionCard sits inside .group-body--form; no height constraint needed\r\n  &.group-body--form {\r\n    min-height: unset;\r\n    max-height: unset;\r\n    overflow-y: visible;\r\n    padding: 0;\r\n  }\r\n}\r\n\r\n// ── Tree group-section fills remaining height in select tab ────\r\n.group-section.tree-section {\r\n  flex: 1;\r\n  min-height: 0;\r\n  overflow: hidden;\r\n  display: flex;\r\n  flex-direction: column;\r\n\r\n  .group-body {\r\n    flex: 1;\r\n    min-height: 0;\r\n    max-height: unset;\r\n  }\r\n}\r\n\r\n// ── Selected region feedback ─────────────────────────────────\r\n.selected-region-feedback {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 7px;\r\n  padding: 7px 12px;\r\n  border-radius: 8px;\r\n  background: rgba(var(--ion-color-medium-rgb), 0.08);\r\n  border: 1px solid rgba(var(--ion-color-medium-rgb), 0.15);\r\n  font-size: var(--font-size-small);\r\n  color: var(--ion-color-medium);\r\n  flex-shrink: 0;\r\n\r\n  ion-icon {\r\n    font-size: 17px;\r\n    flex-shrink: 0;\r\n  }\r\n\r\n  span {\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    white-space: nowrap;\r\n  }\r\n\r\n  &.has-selection {\r\n    background: rgba(var(--ion-color-success-rgb), 0.09);\r\n    border-color: rgba(var(--ion-color-success-rgb), 0.3);\r\n    color: var(--ion-color-success-shade);\r\n\r\n    ion-icon { color: var(--ion-color-success); }\r\n  }\r\n}\r\n\r\n// ── Panel footer ─────────────────────────────────────────────\r\n.panel-footer {\r\n  flex-shrink: 0;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: flex-end;\r\n  gap: 6px;\r\n  padding-top: 10px;\r\n  border-top: 1px solid rgba(0, 0, 0, 0.06);\r\n  margin-top: 8px;\r\n}\r\n\r\n// ── Map panel ────────────────────────────────────────────────\r\n.map-panel {\r\n  flex: 1;\r\n  min-width: 0;\r\n  position: relative;\r\n  display: flex;\r\n  flex-direction: column;\r\n\r\n  app-leaflet-map {\r\n    flex: 1;\r\n    min-height: 0;\r\n    display: block;\r\n    height: 100%;\r\n  }\r\n}\r\n\r\n// ── Map mode badge ───────────────────────────────────────────\r\n.map-mode-badge {\r\n  position: absolute;\r\n  top: 10px;\r\n  right: 10px;\r\n  z-index: 1000;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 5px;\r\n  padding: 5px 11px;\r\n  border-radius: 20px;\r\n  font-size: 11px;\r\n  font-weight: 700;\r\n  background: rgba(var(--ion-color-light-rgb), 0.9);\r\n  color: var(--ion-color-medium);\r\n  border: 1px solid rgba(var(--ion-color-medium-rgb), 0.22);\r\n  backdrop-filter: blur(4px);\r\n  pointer-events: none;\r\n  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.12);\r\n\r\n  ion-icon { font-size: 13px; }\r\n\r\n  &.draw-mode {\r\n    background: rgba(var(--ion-color-primary-rgb), 0.14);\r\n    color: var(--ion-color-primary);\r\n    border-color: rgba(var(--ion-color-primary-rgb), 0.38);\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
